import { render, staticRenderFns } from "./Assume.vue?vue&type=template&id=4ca49755&"
import script from "./Assume.vue?vue&type=script&lang=js&"
export * from "./Assume.vue?vue&type=script&lang=js&"
import style0 from "./Assume.vue?vue&type=style&index=0&id=4ca49755&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports